/**
 * Orbi chat message kinds. Mirrors the mobile `OrbiMessageType`
 * (`lib/orbi/enums/orbi_message_type.dart`) for parity:
 *  - `User`    — a message the patient sent
 *  - `Llm`     — an assistant/agent answer
 *  - `Loading` — placeholder shown while awaiting the agent response
 *  - `Error`   — a recoverable error bubble (e.g. HTTP 503) offering retry
 */
export enum OrbiMessageType {
  User = 'user',
  Llm = 'llm',
  Loading = 'loading',
  Error = 'error',
}
